import { createTheme }   from "@mui/material/styles";
import { blue }          from "@mui/material/colors";
import { APP_MAX_WIDTH } from "_config/index";

export const lightTheme = {
	globals: {
		appMaxWidth   : APP_MAX_WIDTH,
		blueShade     : "#2283f6",
		downloadGreen : "#19b85c"
	},
	palette: {
		primary: blue

	}
};

export const commonOverrides = {
	 MuiTab: {
		// Name of the component ⚛️ / style sheet
		root: {
			// Name of the rule
			maxWidth: "initial" // Some CSS
		}
	},
	MuiButton: {
		root: {
			maxWidth: APP_MAX_WIDTH
		}
	},
	MuiButtonBase: {
		root: {
			maxWidth: APP_MAX_WIDTH
		}
	},
	MuiModal: {
		root: {
			maxWidth : APP_MAX_WIDTH,
			left     : 0
		}
	},
	MuiBackdrop: {
		root: {
			maxWidth : APP_MAX_WIDTH,
			left     : 0
		}
	},
	MuiBottomNavigation: {
		root: {
			backgroundColor : "#fff",
			boxShadow       : "0 -6px 10px rgba(100,100,100,0.1)"
		}
	}
};

export default createTheme ( { ...lightTheme, ...commonOverrides } );
